import { combineReducers } from 'redux';
import banners, { fetchBanners } from './bannerReducer.js';
import links, { startLinkCountTimer, stopLinkCountTimer, fetchMayoFormUrl, fetchMayoReportUrl } from './linkReducer.js';
import {
  setMessage,
  resetMessage,
} from 'containers/App/screens/Tube/reducers/messageReducer';

export const actions = {
  fetchBanners,
  fetchMayoFormUrl,
  fetchMayoReportUrl,
  startLinkCountTimer,
  stopLinkCountTimer,
  setMessage,
  resetMessage,
};

export default combineReducers({
  banners,
  links,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/reducers/index.js
 **/